import { gql } from '@apollo/client';
import { SALES_ORDER_FRAGMENT } from './SALES_ORDER_FRAGMENT';

export const COMPLETE_SALES_ORDER_MUTATION = gql`
  mutation CompleteSalesOrder($id: Int!) {
    o {
      completeSalesOrder(id: $id) {
        success
        message {
          code
          message
        }
        content {
          ...SalesOrderFragment
        }
      }
    }
  }
  ${SALES_ORDER_FRAGMENT}
`;
